import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () =>
  import ('@/containers/DefaultContainer')

// Views
const Dashboard = () =>
  import ('@/views/Dashboard')

// Views - Pages
const Page404 = () =>
  import ('@/views/pages/Page404')
const Page500 = () =>
  import ('@/views/pages/Page500')
const Login = () =>
  import ('@/views/pages/Login')

import Admins from '@/views/admins/router.js'
import Users from '@/views/users/router.js'
import Products from '@/views/products/products/router.js'
import Prodaggregs from '@/views/products/prodaggregs/router.js'
import Brands from '@/views/products/brands/router.js'
import Divisions from '@/views/products/divisions/router.js'
import Categories from '@/views/products/categories/router.js'
import ShoppingGroups from '@/views/products/shoppinggroups/router.js'
import Subsectors from '@/views/products/subsectors/router.js'
import Top10 from '@/views/products/top10/router.js'
import Varieties from '@/views/products/varieties/router.js'

import Dealers from '@/views/dealers/dealers/router.js'
import LastSales from '@/views/dealers/lastsales/router.js'
import Dsr from '@/views/dealers/dsr/router.js'
import DsrCodes from "@/views/dealers/dsr_codes/router.js";
import Teams from '@/views/dealers/teams/router.js'
import Operators from '@/views/dealers/operators/router.js'
import OperatorsExcluded from '@/views/dealers/operators_excluded/router.js'
import OperatorGroups from '@/views/dealers/operator_groups/router.js'
import DealerProducts from '@/views/dealers/products/router.js'

import Bestof from '@/views/campaigns/bestof/campaigns/router.js'
import Bestoftypes from '@/views/campaigns/bestof/campaigntypes/router.js'
import CampaignsApp from '@/views/campaigns/bestof/campaignsapp/router.js'
import BestofObjectives from '@/views/campaigns/bestof/objectives/router.js'
import BestofDsrObjectives from '@/views/campaigns/bestof/dsrobjectives/router.js'
import BestofLeaderObjectives from '@/views/campaigns/bestof/leaderobjectives/router.js'

import BestofResults from '@/views/campaigns/bestof/results/router.js'
import BestofDsrResults from '@/views/campaigns/bestof/resultsdsr/router.js'
import BestofLeaderResults from '@/views/campaigns/bestof/leaderresults/router.js'

import Criteria from '@/views/campaigns/inpar/criteria/router.js'
import Bonus from '@/views/campaigns/inpar/bonus/router.js'
import InparResults from '@/views/campaigns/inpar/results/router.js'
import InparLeaderResults from '@/views/campaigns/inpar/leaderresults/router.js'
import InparExcludedOperators from '@/views/campaigns/inpar/excluded/router.js'
import Extra from '@/views/campaigns/extra/router.js'
import Ola from '@/views/campaigns/ola/router.js'

import ScorecardExcluded from '@/views/scorecard/excluded/router.js'
import ScorecardObjectives from '@/views/scorecard/objectives/router.js'
import ScorecardResults from '@/views/scorecard/results/router.js'

import ScIndependentsOperators from '@/views/scorecard/independents/operators/router.js'
import ScIndependentsObjectives from '@/views/scorecard/independents/objectives/router.js'
import ScIndependentsResults from '@/views/scorecard/independents/results/router.js'

import Sellout from '@/views/sales/sellout/router.js'
import Distsales from '@/views/sales/distsales/router.js'
import Sellin from '@/views/sales/sellin/router.js'
import SellinNew from '@/views/sales/sellinnew/router.js'
import Remake from '@/views/sales/remake/router.js'

import Calcs from '@/views/calcs/router.js'
import SiteRegistrations from '@/views/siteregistrations/router.js'

import StarsWSRelations from '@/views/stars/ws_relations/router.js'
import StarsWSObjectives from '@/views/stars/ws_objectives/router.js'
import StarsWSObjectivesQuarter from '@/views/stars/ws_objectives_quarter/router.js'
import SellinObjectives from '@/views/stars/sellin_objectives/router.js'
import ShiptoObjectives from '@/views/stars/shipto_objectives/router.js'
import Points from '@/views/points/points.vue'
import PointsMonth from '@/views/points/points_month.vue'
import PointsMonthNew from '@/views/points/points_month_new.vue'
import PointsMonthDetail from '@/views/points/points_month_detail.vue'
import PointsYear from '@/views/points/points_year.vue'
import PointsSpent from '@/views/points/points_spent.vue'
import PointsBalance from '@/views/points/points_balance.vue'
import PointsOla from '@/views/points/points_ola.vue'

import Settings from '@/views/settings/router.js'

// NEW BO 
import PullRequests from '@/views/isolated/pull_requests/router.js'
import Submited from '@/views/isolated/submitted/router.js'

import Logout from '@/views/logout/logout.vue'
import Teamsnew from '@/views/dealers/teams-new/router.js'
import SelloutNew from '@/views/sales/selloutnew/router.js'
import DsrNew from '@/views/dealers/dsr-new/router.js'

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [
    {
      path: '*',
      component: Page404
    },
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: DefaultContainer,
      meta: {
        auth: true
      },
      children: [
        {
          path: 'dashboard',
          name: 'dashboard',
          component: Dashboard
        },
        {
          path: 'points',
          name: 'points',
          component: Points
        }, {
          path: 'points_month',
          name: 'points_month',
          component: PointsMonth
        }, {
          path: 'points_month_new',
          name: 'points_month_new',
          component: PointsMonthNew,
          meta: {
            auth: true,
            roles: ['SUPER'],
            forbiddenRedirect: '/dashboard'
          }
        }, {
          path: 'points_month_detail',
          name: 'points_month_detail',
          component: PointsMonthDetail,
          meta: {
            auth: true,
            roles: ['SUPER'],
            forbiddenRedirect: '/dashboard'
          }
        }, {
          path: 'points_year',
          name: 'points_year',
          component: PointsYear
        }, {
          path: 'points_spent',
          name: 'points_spent',
          component: PointsSpent
        }, {
          path: 'points_balance',
          name: 'points_balance',
          component: PointsBalance
        }, {
          path: 'points_ola',
          name: 'points_ola',
          component: PointsOla
        },
        {
          path: '/logout',
          name: 'Logout',
          component: Logout
        },
        Admins, Users, Products, Prodaggregs, Brands, Divisions, Categories, ShoppingGroups, Subsectors, Top10, Varieties,
        Dealers, LastSales, Dsr, DsrCodes, Teams, Operators, OperatorsExcluded, OperatorGroups, DealerProducts,
        Bestof, BestofObjectives, BestofDsrObjectives, BestofLeaderObjectives, BestofResults, BestofDsrResults, BestofLeaderResults,
        Criteria, Bonus, InparResults, InparLeaderResults, InparExcludedOperators, ScorecardExcluded, ScorecardObjectives, ScorecardResults,
        Sellout, SelloutNew, Sellin, SellinNew, Distsales, Remake, Submited, PullRequests, Teamsnew, DsrNew,
        ScIndependentsOperators, ScIndependentsObjectives, ScIndependentsResults,
        Calcs, Extra, Ola, CampaignsApp, Bestoftypes,
        SiteRegistrations,
        StarsWSRelations, StarsWSObjectives, StarsWSObjectivesQuarter, SellinObjectives, ShiptoObjectives,
        Settings
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
      {
        path: '404',
        name: 'Page404',
        component: Page404
      },
      {
        path: '500',
        name: 'Page500',
        component: Page500
      }]
    },

  ]
})
